// ----------------------------
// CAPTURE CS AGENT FROM URL
// ----------------------------
(function() {
  function getParam(param) {
    const url = new URL(window.location.href);
    return url.searchParams.get(param);
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  // Capture CS agent from URL
  const agent = getParam('cs_agent');
  if (agent) {
    document.cookie = "cs_agent=" + agent + "; path=/; max-age=" + (3*24*60*60);
  }

  const savedAgent = getCookie('cs_agent');

  if (savedAgent) {
    // Only update cart attributes (do not touch cart note)
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          cs_agent: savedAgent,
          site: "Canada"
        }
      })
    }).catch(() => {});
  }
})();
